import { log2 } from "../../utils/log2";
import { CHATBOT_API } from "../../api/chatbotv2";
import { AUTOMATION_API } from "../../api/automation";

const log = log2("store.automation");

const automation = {
    namespaced: true,
    state: {
        current: null,
        testState: {
            active: false,
            startBlockId: null,
            history: [],
            position: null,
        },
        automations: [],
    },
    getters: {},
    mutations: {
        setCurrentAutomation(state, current) {
            log("setCurrentAutomation", current);
            state.current = current;
        },
        setTestState(state, testState) {
            log("setTestState", testState);
            state.testState = testState;
        },
        SET_AUTOMATIONS(state, automations) {
            state.automations = automations;
        },
    },
    actions: {
        async syncAutomations({ commit }) {
            AUTOMATION_API.listAutomations([], {
                page: 0,
                perPage: 1000,
            }).then((data) => {
                log("syncAutomations", data);
                if (Array.isArray(data?.items)) commit("SET_AUTOMATIONS", data?.items);
            });
        },
        async updateBlock({ commit, state }, { id, blockId, payload }) {
            try {
                id = id || state.current._id;
                const data = await AUTOMATION_API.DESIGN.updateBlock(id, blockId, payload);
                log("updateBlock", data);
                data.id = data._id;
                commit("setCurrentAutomation", data);
            } catch (e) {
                log.error(e);
            }
        },
        async copyBlock({ commit, state }, { sourceBlockId, targetBlockId }) {
            try {
                const id = state.current._id;
                const data = await AUTOMATION_API.DESIGN.copyBlock(id, sourceBlockId, targetBlockId);
                log("copyBlock", data);
                data.id = data._id;
                commit("setCurrentAutomation", data);
            } catch (e) {
                log.error(e);
            }
        },
        async moveBlock({ commit, state }, { sourceBlockId, targetBlockId }) {
            try {
                const id = state.current._id;
                const data = await AUTOMATION_API.DESIGN.moveBlock(id, sourceBlockId, targetBlockId);
                log("moveBlock", data);
                data.id = data._id;
                commit("setCurrentAutomation", data);
            } catch (e) {
                log.error(e);
            }
        },
        async publishAutomation({ commit, state }, { id }) {
            try {
                id = id || state.current._id;
                const data = await AUTOMATION_API.updateAutomationSingleKey(id, "published", true);
                log("publishAutomation", data);
                data.id = data._id;
                commit("setCurrentAutomation", data);
            } catch (e) {
                log.error(e);
            }
        },
        async unPublishAutomation({ commit, state }, { id }) {
            try {
                id = id || state.current._id;
                const data = await AUTOMATION_API.updateAutomationSingleKey(id, "published", false);
                log("publishAutomation", data);
                data.id = data._id;
                commit("setCurrentAutomation", data);
            } catch (e) {
                log.error(e);
            }
        },
        async changeAutomationName({ commit, state }, name) {
            try {
                const id = state.current._id;
                const data = await AUTOMATION_API.updateAutomationSingleKey(id, "name", name);
                data.id = data._id;
                commit("setCurrentAutomation", data);
            } catch (e) {
                log.error(e);
            }
        },
        async changeTestSate({ commit, state }, payload) {
            try {
                commit("setTestState", payload);
            } catch (e) {
                log.error(e);
            }
        },
    },
};

export default automation;
